import { IconProps } from './types';

const TlAuditIcon = (props: IconProps) => {
  const { width = 20, height = 20, fillColor = 'var(--charcoal-grey)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 9C12.0711 9 13.75 7.32107 13.75 5.25C13.75 3.17893 12.0711 1.5 10 1.5C7.92893 1.5 6.25 3.17893 6.25 5.25C6.25 7.32107 7.92893 9 10 9Z"
        stroke={fillColor}
        strokeLinejoin="round"
      />
      <path
        d="M17.4926 16.5L17.5 17.2925C17.5 17.958 16.9206 18.5 16.1927 18.5H3.81468C3.09421 18.5 2.50743 17.9649 2.50743 17.2925L2.5 16.5C2.5 13.7763 4.21392 12.068 6.97698 11.3613C8.90072 10.8742 11.0993 10.8742 13.0305 11.3613C13.0676 11.375 13.1122 11.3887 13.1567 11.3956C15.8604 12.116 17.4926 13.8243 17.4926 16.5Z"
        stroke={fillColor}
        strokeLinejoin="round"
      />
      <path
        d="M10 17L8.69408 15.6941C8.5732 15.5732 8.52246 15.3989 8.55954 15.2321L9.5 11H10.5L11.4405 15.2321C11.4775 15.3989 11.4268 15.5732 11.3059 15.6941L10 17Z"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TlAuditIcon;
